export default {
      id: "nav_fleche_gauche-usage",
      viewBox: "0 0 9 16",
      url: "../dist/images/" + "sprite.svg#nav_fleche_gauche-usage",
      toString: function () {
        return this.url;
      }
    }